import { CheckCircleOutlined, CopyOutlined } from '@ant-design/icons'
import { Button, ButtonProps, message } from 'antd'
import React, {
  CSSProperties,
  FunctionComponent,
  memo,
  useCallback,
  useMemo,
  useState,
} from 'react'

interface CopyButtonProps {
  copyText: string
  paragraphStyle?: CSSProperties
  paragraphClassName?: string
  buttonsProps?: ButtonProps
  buttonsTextClassName?: string
  copyButtonProps?: ButtonProps
  copyButtonText?: string
  copiedButtonProps?: ButtonProps
  copiedButtonText?: string
}

export const CopyButton: FunctionComponent<CopyButtonProps> = memo(
  ({
    copyText,
    paragraphStyle,
    paragraphClassName,
    buttonsProps,
    buttonsTextClassName,
    copyButtonProps,
    copyButtonText,
    copiedButtonProps,
    copiedButtonText,
  }) => {
    const [isCopied, setIsCopied] = useState(false)

    const doCopy = useCallback(async () => {
      try {
        if (!navigator?.clipboard?.writeText) {
          throw new Error('Clipboard API není dostupné')
        }
        await navigator.clipboard.writeText(copyText)

        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 3000)
      } catch (error) {
        message.error('Kopírování se nezdařilo.')
      }
    }, [copyText])

    const handleClick = useCallback<NonNullable<ButtonProps['onClick']>>(
      event => {
        event.preventDefault()
        event.stopPropagation()
        void doCopy()
      },
      [doCopy]
    )

    const containerClassName = useMemo(
      () => `${paragraphClassName || ''} ${isCopied ? 'opacity-100' : ''}`,
      [paragraphClassName, isCopied]
    )

    return (
      <div
        className={containerClassName}
        style={{ margin: 0, ...paragraphStyle }}
      >
        <Button
          ghost
          type="primary"
          icon={isCopied ? <CheckCircleOutlined /> : <CopyOutlined />}
          {...buttonsProps}
          {...(isCopied ? copiedButtonProps : copyButtonProps)}
          onClick={handleClick}
        >
          <span className={buttonsTextClassName}>
            {isCopied ? copiedButtonText : copyButtonText}
          </span>
        </Button>
      </div>
    )
  }
)
